import { render, staticRenderFns } from "./ai-steps.vue?vue&type=template&id=67c61418&lang=pug&"
import script from "./ai-steps.vue?vue&type=script&lang=js&"
export * from "./ai-steps.vue?vue&type=script&lang=js&"
import style0 from "./ai-steps.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports